import React, { useState } from 'react';
import { CapagTypes } from 'store/modules/bidding_store/types';
import { Container, ContainerButton } from './styles';
import ModalCapag from '../modal_capag';

interface CapagProps {
  capag: CapagTypes;
}

const Capag = ({ capag }: CapagProps) => {
  const indicators = [
    {
      label: 'Endividamento',
      rating: capag.debt_rating,
      ratio: capag.debt_ratio,
    },
    {
      label: 'Poupança Corrente',
      rating: capag.current_savings_rating,
      ratio: capag.current_savings_ratio,
    },
    {
      label: 'Liquidez Relativa',
      rating: capag.relative_liquidity_rating,
      ratio: capag.relative_liquidity_ratio,
    },
  ];

  const [showModalCapag, setShowModalCapag] = useState(false);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  return (
    <Container className="d-inline-flex align-items-center">
      <ContainerButton variant={capag.capag} className="rounded ml-3">
        <button
          ref={buttonRef}
          type="button"
          className="btn"
          onClick={() => setShowModalCapag(!showModalCapag)}
        >
          <span className="capag-text">CAPAG</span>{' '}
          <span className="capag-value">{capag.capag}</span>
        </button>
      </ContainerButton>
      <ModalCapag
        show={showModalCapag}
        title={capag.capag}
        indicators={indicators}
        key={capag.id}
        onClose={() => setShowModalCapag(false)}
      />
    </Container>
  );
};

export default Capag;
